import { useCallback, useEffect, useState } from 'react';

interface PaginationProps<T> {
  currentPage: number;
  pageSize: number;
  handlePageChange: (page: number, newPageSize?: number) => void;
  getPaginatedData: (data: T[]) => T[];
}
export const usePagination = <T,>(defaultPageSize = 10, dependencies: any[] = []): PaginationProps<T> => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(defaultPageSize);

  useEffect(() => {
    setCurrentPage(1);
  }, dependencies);

  const handlePageChange = useCallback((page: number, newPageSize?: number): void => {
    setCurrentPage(page);
    if (newPageSize) {
      setPageSize(newPageSize);
    }
  }, []);

  const getPaginatedData = useCallback(
    (data: T[]): T[] => {
      return data.slice((currentPage - 1) * pageSize, currentPage * pageSize);
    },
    [currentPage, pageSize],
  );

  return {
    currentPage,
    pageSize,
    handlePageChange,
    getPaginatedData,
  };
};
